<section id="recover-password" class="login-page recover-password-page">
  <div class="login-grid">

    <div class="login-form-col">
      <div class="login-form-shell">
        <div class="login-brand">
          <img src="/assets/img/brand/mymeds-logo-mark.svg" alt="MyMedsPH" class="login-brand-mark" />
          <span class="login-brand-name">
            <span class="login-brand-name-orange">MyMeds</span><span class="login-brand-name-blue">PH</span>
          </span>
        </div>

        <header class="login-greeting">
          <h1>Set a New Password</h1>
          <p>Confirm your email and choose a new password to finish recovering your account.</p>
        </header>

        <form
          name="form"
          class="login-form"
          (ngSubmit)="f.form.valid && onSubmit()"
          #f="ngForm"
          novalidate>
          <div class="login-field">
            <label for="recover-email">Email</label>
            <input
              type="email"
              class="form-control"
              name="email"
              id="recover-email"
              [(ngModel)]="model.email"
              #email="ngModel"
              [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
              required
              email
              autocomplete="email"
              placeholder="you@clinic.com" />
            <div *ngIf="f.submitted && email.invalid" class="auth-field-error" role="alert">
              <span *ngIf="email.errors?.required">Email is required.</span>
              <span *ngIf="email.errors?.email && !email.errors?.required">Enter a valid email address.</span>
            </div>
          </div>

          <div class="login-field">
            <label for="recover-password">New password</label>
            <div class="recover-password-input">
              <input
                [type]="isPasswordVisible ? 'text' : 'password'"
                class="form-control"
                name="password"
                id="recover-password"
                [(ngModel)]="model.password"
                #password="ngModel"
                [ngClass]="{ 'is-invalid': f.submitted && password.invalid }"
                required
                autocomplete="new-password"
                placeholder="Enter your new password" />
              <button
                type="button"
                class="recover-password-toggle"
                (click)="togglePasswordVisibility()"
                [attr.aria-label]="isPasswordVisible ? 'Hide password' : 'Show password'"
                [attr.aria-pressed]="isPasswordVisible">
                <i class="fas" [ngClass]="isPasswordVisible ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
              </button>
            </div>
            <div *ngIf="f.submitted && password.invalid" class="auth-field-error" role="alert">
              <span *ngIf="password.errors?.required">Password is required.</span>
            </div>
          </div>

          <button type="submit" class="login-submit btn btn-info btn-block btn-raised" [disabled]="submitted">
            <span *ngIf="!submitted">Update password</span>
            <span *ngIf="submitted"><i class="fas fa-circle-notch fa-spin" aria-hidden="true"></i> Updating…</span>
          </button>
        </form>

        <footer class="login-footer">
          <a routerLink="/auth/login" class="login-forgot">Back to sign in</a>
        </footer>
      </div>
    </div>

    <aside class="login-brand-panel" aria-hidden="true">
      <div class="brand-panel-glow"></div>
      <div class="brand-panel-mark">
        <img src="/assets/img/brand/mymeds-logo-mark.svg" alt="" />
      </div>
      <div class="brand-panel-content">
        <p class="brand-panel-eyebrow">Password recovery</p>
        <h2>Choose a Strong New Password</h2>
        <p>Use the email from your reset link and set a password you have not used on this account before.</p>
        <ul class="brand-panel-features">
          <li><i class="fas fa-key" aria-hidden="true"></i><span>Secure password reset from your email link</span></li>
          <li><i class="fas fa-shield-alt" aria-hidden="true"></i><span>Recovery links expire for your protection</span></li>
          <li><i class="fas fa-sign-in-alt" aria-hidden="true"></i><span>Sign in again once your password is updated</span></li>
        </ul>
      </div>
      <div class="brand-panel-footer">
        <span>© {{ today | date:'y' }} MyMedsPH</span>
        <a href="https://mymedsph.com" target="_blank" rel="noopener noreferrer">mymedsph.com</a>
      </div>
    </aside>

  </div>
</section>
